import api from "../../../components/axiosComp";

export const createLocalGame = async (payload = {}) => {
  const { data } = await api.post("/api/superAdmin/play/local-games", payload);
  return data?.item || data;
};

export const listLocalGames = async (params = {}) => {
  const { data } = await api.get("/api/superAdmin/play/local-games", {
    params,
  });

  return data || { items: [], total: 0, meta: {} };
};

export const listLocalCustomVenues = async (params = {}) => {
  const { data } = await api.get("/api/superAdmin/play/local-games/custom-venues", {
    params,
  });

  return data || { items: [], total: 0, meta: {} };
};

export async function getLocalGameAnalytics(params = {}) {
  const { data } = await api.get("/api/superAdmin/play/local-games/analytics", {
    params,
  });

  return data;
}

export const getLocalGameDetail = async (id) => {
  if (!id) throw new Error("Missing local game id");

  const { data } = await api.get(`/api/superAdmin/play/local-games/${id}`);
  return data?.item || null;
};

export const listLocalGameChatMessages = async (id, params = {}) => {
  if (!id) throw new Error("Missing local game id");

  const { data } = await api.get(
    `/api/superAdmin/play/local-games/${id}/chat/messages`,
    { params }
  );

  return data || { items: [], total: 0, meta: {} };
};

export const cancelLocalGame = async (id, payload = {}) => {
  if (!id) throw new Error("Missing local game id");

  const { data } = await api.patch(
    `/api/superAdmin/play/local-games/${id}/cancel`,
    payload
  );

  return data;
};

export const toggleLocalGameChat = async (id, payload = {}) => {
  if (!id) throw new Error("Missing local game id");

  const { data } = await api.patch(
    `/api/superAdmin/play/local-games/${id}/chat/toggle`,
    payload
  );

  return data;
};